var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { makeStateUpdater } from "../../utils";
import { throwError } from "../../utilities/errors";
const promiseErrorMessage = "sync dataLoader returned promise";
export const syncDataLoaderFeature = {
    key: "sync-data-loader",
    getInitialState: (initialState) => (Object.assign({ loadingItemData: [], loadingItemChildrens: [] }, initialState)),
    getDefaultConfig: (defaultConfig, tree) => (Object.assign({ setLoadingItemData: makeStateUpdater("loadingItemData", tree), setLoadingItemChildrens: makeStateUpdater("loadingItemChildrens", tree) }, defaultConfig)),
    stateHandlerNames: {
        loadingItemData: "setLoadingItemData",
        loadingItemChildrens: "setLoadingItemChildrens",
    },
    treeInstance: {
        waitForItemDataLoaded: () => __awaiter(void 0, void 0, void 0, function* () { }),
        waitForItemChildrenLoaded: () => __awaiter(void 0, void 0, void 0, function* () { }),
        retrieveItemData: ({ tree }, itemId) => {
            const data = tree.getConfig().dataLoader.getItem(itemId);
            if (typeof data === "object" && "then" in data) {
                throw throwError(promiseErrorMessage);
            }
            return data;
        },
        retrieveChildrenIds: ({ tree }, itemId) => {
            const data = tree.getConfig().dataLoader.getChildren(itemId);
            if (typeof data === "object" && "then" in data) {
                throw throwError(promiseErrorMessage);
            }
            return data;
        },
    },
    itemInstance: {
        isLoading: () => false,
    },
};
